import createIcon from '../../createIcon';

/**
 * @component @name WebAssetOff
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNy40ODQ3MyAzLjI5NTAySDIwLjY1NDdDMjEuNzY0NyAzLjI5NTAyIDIyLjY1NDcgNC4xOTUwMiAyMi42NTQ3IDUuMjk1MDJWMTcuMjk1QzIyLjY1NDcgMTcuNjM1IDIyLjU2NDcgMTcuOTU1IDIyLjQyNDcgMTguMjM1TDIwLjY1NDcgMTYuNDY1VjcuMjk1MDJIMTEuNDg0N0w3LjQ4NDczIDMuMjk1MDJaTTIxLjE0NDcgMjIuNjA1TDE3LjgyNDcgMTkuMjk1SDQuNjU0NzNDMy41NDQ3MyAxOS4yOTUgMi42NTQ3MyAxOC4zOTUgMi42NTQ3MyAxNy4yOTVWNS4yOTUwMkMyLjY1NDczIDQuOTU1MDIgMi43MzQ3MyA0LjYzNTAyIDIuODg0NzMgNC4zNTUwMkwxLjM0NDczIDIuODA1MDJMMi43NTQ3MyAxLjM5NTAyTDIyLjU1NDcgMjEuMTk1TDIxLjE0NDcgMjIuNjA1Wk0xNS44MjQ3IDE3LjI5NUw1LjgyNDczIDcuMjk1MDJINC42NTQ3M1YxNy4yOTVIMTUuODI0N1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const WebAssetOff = createIcon('WebAssetOff', [
  [
    'path',
    {
      d: 'M7.48473 3.29502H20.6547C21.7647 3.29502 22.6547 4.19502 22.6547 5.29502V17.295C22.6547 17.635 22.5647 17.955 22.4247 18.235L20.6547 16.465V7.29502H11.4847L7.48473 3.29502ZM21.1447 22.605L17.8247 19.295H4.65473C3.54473 19.295 2.65473 18.395 2.65473 17.295V5.29502C2.65473 4.95502 2.73473 4.63502 2.88473 4.35502L1.34473 2.80502L2.75473 1.39502L22.5547 21.195L21.1447 22.605ZM15.8247 17.295L5.82473 7.29502H4.65473V17.295H15.8247Z',
      key: 'mskmih',
    },
  ],
]);

export default WebAssetOff;
